import { Link, useParams } from "react-router-dom";
import heContent from "../languages/hebrew.json"
import arContent from "../languages/arabic.json"
import { BottomNavbar, Footer, Navbar } from "../components";
import { RiWhatsappFill } from 'react-icons/ri';
import { FaShare } from 'react-icons/fa';
import { url, bizNUM, bizNUM2, defaultImage, getCategorySlug } from '../utils/Utils'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const Product = ({ endPoint }) => {

    const { productId, categoryName } = useParams()
    // NEW Patch: Fix manual URL entry for share url / Check Cagtegory language
    const isArabicCategory = arContent.categories.some(cat => getCategorySlug(cat.name) === categoryName);
    const contentLng = isArabicCategory ? arContent : heContent;
    // Check if the category exists in the selected language
    const category = contentLng.categories.find(cat => getCategorySlug(cat.name) === categoryName);
    if (!category) return <div style={{ padding: 40 }}>⚠️ Category not found: {categoryName}</div>;
    // Try to find product by sku first, then by index if productId is numeric
    let product = category.products.find(product => product.sku === productId);
    if (!product && !isNaN(productId)) {
        const index = parseInt(productId, 10);
        product = category.products[index];
    }
    if (!product) return <div style={{ padding: 40 }}>⚠️ Product not found: {productId}</div>;

    const { Prenote, boldInNote, restOfNote,whatsappDetails: { wspMsgStart, shareBtn, orderBtn, meal, s, m, b, xb,sNoBurger,mNoBurger, bNoBurger } } = contentLng
    // Normalize picture path: remove leading slash if present, then add /products/ prefix
    // Encode the path properly for URLs with Hebrew characters
    let defaultPic;
    if (product.picture) {
      const normalizedPath = product.picture.startsWith('/') ? product.picture.slice(1) : product.picture;
      // Split path and encode each segment separately to preserve slashes
      const pathSegments = normalizedPath.split('/').map(segment => encodeURIComponent(segment));
      defaultPic = `${endPoint}/products/${pathSegments.join('/')}`;
    } else {
      defaultPic = `${endPoint}/${defaultImage}`;
    }
    const notIndividualPrices = (
        <div className='notIndividualPrices product-page'>
      {product.persons >= 1 && 
        <a className="product-price p1" href={`https://api.whatsapp.com/send?phone=${bizNUM}&text=${wspMsgStart} ${meal} ${product.name} ${s}.`}>
          ₪{product.price}<br/>{product.category === 'בורגרים 🍔' ? s : sNoBurger }
        </a>
      }
  
  {product.persons >= 3 && 
    <a className="product-price p3" href={`https://api.whatsapp.com/send?phone=${bizNUM}&text=${wspMsgStart} ${meal} ${product.name} ${m}.`}>
      ₪{product.mPrice}<br/>{product.category === 'בורגרים 🍔' ? m : mNoBurger }
    </a>
  }
      {product.persons >= 2 && 
        <a className="product-price p2" href={`https://api.whatsapp.com/send?phone=${bizNUM}&text=${wspMsgStart} ${meal} ${product.name} ${b}.`}>
          ₪{product.bPrice}<br/>{product.category === 'בורגרים 🍔' ? b : bNoBurger}
        </a>
      }
      
      
          {product.persons === 4 && 
            <a className="product-price" href={`https://api.whatsapp.com/send?phone=${bizNUM}&text=${wspMsgStart} ${meal} ${product.name} ${xb}.`}>
              ₪{product.xbPrice}<br/>{xb}
            </a>
          }
        </div>
      );

    return (
        <>
    <Navbar endPoint={endPoint} />
    <div className='Product' style={productStyle}>
        <Link to={`/${categoryName}`}>
            <button style={{margin:'20px 15px'}} className='showAllBtn'>
                <ArrowForwardIosIcon />{categoryName}
            </button>
        </Link>
        <h1 style={{ marginTop: '30px' }}>{product.name}</h1>
        <p style={{padding:'0px 40px'}}>{product.desc}</p>
        {product.persons > 1 ? notIndividualPrices : 
            <div className="notIndividualPrices" style={{justifyContent:'center'}}> 
                <div className="product-price">₪{product.price}</div>
            </div>
        }
        <img src={`${defaultPic}`} style={{ margin: '10px 0px', height: '60vw', width: '75vw', borderRadius:'10px',objectFit:"cover" }} alt="Risto Steak House | ריסתו סטייק האוס" />
        
        {/* Add-ons Section */}
        {/* <div className="addons" style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', padding: '20px 55px' }}>
            <div>
                <p>בצל מטוגן 3₪</p>
            </div>
            <div>
                <p>אקסטרה גבינה 5₪</p>
            </div>
            <div>
                <p>פלפל חריף 3₪</p>
            </div>
            <div>
                <p>פטריות 7₪</p>
            </div>
            <div>
                <p>ביצת עין 7₪</p>
            </div>
            <div>
                <p>מזרק גבינה 15₪</p>
            </div>
            <div>
                <p>כתף בקר 12₪</p>
            </div>
            <div>
                <p>אסאדו 15₪</p>
            </div>
        </div> */}

        {/* Modal Buttons */}
        <div className="modal-buttons">
            <a className="product-page-btns" href={`https://api.whatsapp.com/send?phone=${bizNUM}&text=${wspMsgStart} ${product.name}.`}>
                <RiWhatsappFill size={20} />{orderBtn}
            </a>
            <a className="product-page-btns" href={`whatsapp://send?text=${product.name} ב${product.price} ${url}${categoryName}/${productId}`} data-action="share/whatsapp/share" rel="noreferrer" target="_blank" >
                <FaShare size={20} />{shareBtn}
            </a>
        </div>

        <p style={{ padding: '35px', marginBottom: '50px' }}>{Prenote} 
            <a href={`tel:${bizNUM2}`} className="link">{boldInNote}</a> {restOfNote}
        </p>
    </div>
    <Footer contentLng={contentLng} />
    <BottomNavbar />
</>

    )
}

const productStyle = {
    height: 'auto',
    marginTop: '56px',
    backgroundColor:'#fff'
}

export default Product